/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { ITableDataModal } from "pages/StepPages/StepFour/One/Tables/models";
import { useParams } from "react-router-dom";
import ModalPortal from "components-new/ModalPortal";
import sass from "pages/StepPages/StepFour/One/Tables/TableNavigate/LevelsOfVariantsTable/levels.module.sass";
import InputTemp from "components-new/InputTemp";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import GroupCheck from "components-new/GroupCheck";
import { snackWrapper } from "helpers";
import { ChangeActiveTabContext, ITab } from "pages/StepPages/StepFour/One/Tables/TableNavigate/TableNavigate";
import {
	ActualViolatorResponse,
	ActualViolatorTypeResponse,
	ViolatorLevelResponse,
} from "libs/apiClient/data-contracts";
import { directoryAPI } from "libs/apiClient/Directory";
import { organizationAPI } from "libs/apiClient/Organization";

const initial: ActualViolatorResponse = {
	id: 0,
	level: "",
	type: "",
	inner: false,
	outer: false,
	riskType: "",
};

const CurrentViolantModal: React.FC<ITableDataModal<ActualViolatorResponse> & { options: any[] }> = ({
	toggle,
	replace,
	active,
	data = [],
	close,
}) => {
	const params = useParams();

	const [options, setOptions] = useState<ViolatorLevelResponse[]>([]);

	const [currentObject, setCurrentObject] = useState<ActualViolatorResponse>(initial);

	const [currentRiskType, setCurrentRiskType] = useState("");

	const [consequencesOptions, setConsequencesOptions] = useState<{ id: number; name: string }[]>([]);

	const [actualViolatorTypes, setActualViolatorTypes] = useState<ActualViolatorTypeResponse[]>([]);

	const [shortOptionsRisk, setShortOptionsRisk] = useState<{ id: number; name: string }[]>([]);

	const [error, setError] = useState(false);

	const { changeTab, updateTabs } = useContext(ChangeActiveTabContext);
	// const changeField = (e:React.ChangeEvent<HTMLInputElement>|React.ChangeEvent<HTMLTextAreaElement>) => {
	//     const {name,value} = e.target
	//     setCurrentObject((prevState:any) => {
	//         return {...prevState,[name]:value};
	//     })
	// };

	const title = useMemo(() => {
		return `${
			toggle === "edit" ? "Редактирование: " : "Создание: "
		}Актуальные нарушители при реализации угроз безопасности информации и соответствующие им возможности`;
	}, [toggle]);

	const changeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, checked } = e.target;
		setCurrentObject((prevState) => ({ ...prevState, [name]: checked }));
	};
	useEffect(() => {
		if (active) {
			setCurrentObject(active);
			setCurrentRiskType(active.riskType.slice(0, 2));
		} else {
			setCurrentObject(initial);
		}
	}, [active]);

	useEffect(() => {
		if (params.threadId) {
			getOptions(params.threadId).then((r) => {
				setOptions(r[0]);
				setConsequencesOptions(r[1].map((_, index) => ({ id: index + 1, name: _ })));
				setShortOptionsRisk(r[1].map((_, index) => ({ id: index + 1, name: _.slice(0, 2) })));
				setActualViolatorTypes(r[2].map((_, index) => ({ id: index + 1, ..._ })));
			});
		}
		return () => {
			setConsequencesOptions([]);
			setActualViolatorTypes([]);
			setOptions([]);
			setCurrentRiskType("");
			setCurrentObject(initial);
		};
	}, [toggle, params.threadId]);

	const getOptions = async (
		id: number | string,
	): Promise<[ViolatorLevelResponse[], string[], ActualViolatorTypeResponse[]]> => {
		const [violatorLevel, consequences, violatorTypes] = await Promise.all([
			directoryAPI
				.violatorLevelsList({ type: "VIOLATOR" })
				.then((r) => r.data)
				.catch(() => []),
			directoryAPI
				.dropdownConsequencesList({ id: +id })
				.then((r) => r.data)
				.catch(() => []),
			directoryAPI
				.dropdownActualViolatorTypesList({ id: +id })
				.then((r) => r.data)
				.catch(() => []),
		]);
		return [violatorLevel, consequences, violatorTypes];
	};

	const save = () => {
		const { id, ...rest } = currentObject;
		if (toggle === "edit") {
			organizationAPI
				.objectViolatorUpdate(id!, { ...rest, level: rest.level!, type: rest.type! })
				.then((r) => {
					const response = r.data;
					const newData = [...data].map((_) => (_.id === response.id ? response : _));
					setCurrentObject(initial);
					replace(newData);
					snackWrapper("success", "Таблица обновлена");
					updateTabs("VIOLATOR");

					close();
				})
				.catch((error) => {
					if (error.response && error.response.status === 409) {
						setError(true);
						setTimeout(() => {
							setError(false);
						}, 2000);
					}
				});
		} else if (toggle === "create") {
			organizationAPI
				.objectViolatorCreate(+params.threadId!, {
					...rest,
					level: rest.level!,
					type: rest.type!,
				})
				.then((r) => {
					const newData = [...data, r.data];
					setCurrentObject(initial);
					replace(newData);
					snackWrapper("success", "Таблица обновлена");
					updateTabs("VIOLATOR");
					close();
				})
				.catch((error) => {
					if (error.response && error.response.status === 409) {
						setError(true);
						setTimeout(() => {
							setError(false);
						}, 2000);
					}
				});
		}
	};
	const disabled = useMemo(() => {
		return !currentObject.riskType || !currentObject.type || !currentObject.level;
	}, [currentObject]);
	const empty = useMemo(() => {
		return !consequencesOptions.length || !actualViolatorTypes.length;
	}, [consequencesOptions, actualViolatorTypes]);

	const renderEmpty = useMemo(() => {
		const paths = [
			{
				id: 3,
				tab: "objects_of_impact",
				name: "Объекты воздействия и виды воздействия на них",
			},
			{
				id: 4,
				tab: "collusion_groups",
				name: "Группы сговора",
			},
		];
		if (!consequencesOptions.length && !actualViolatorTypes.length) {
			return (
				<p>
					Сначала заполните{" "}
					<span className={sass.link_go_to} onClick={() => changeTab(paths[0] as ITab, false)}>
						таблицу 2
					</span>{" "}
					и{" "}
					<span className={sass.link_go_to} onClick={() => changeTab(paths[1] as ITab, false)}>
						таблицу 3
					</span>
				</p>
			);
		}
		if (!consequencesOptions.length) {
			return (
				<p>
					Сначала заполните{" "}
					<span className={sass.link_go_to} onClick={() => changeTab(paths[0] as ITab, false)}>
						таблицу 2
					</span>
				</p>
			);
		}
		if (!actualViolatorTypes.length) {
			return (
				<p>
					Сначала заполните{" "}
					<span className={sass.link_go_to} onClick={() => changeTab(paths[1] as ITab, false)}>
						таблицу 3
					</span>
				</p>
			);
		}
		return <></>;
		//eslint-disable-next-line
	}, [consequencesOptions, actualViolatorTypes]);

	const selectHandler = (e: { [key: string]: any }, field?: keyof typeof currentObject) => {
		if (!field) {
			const riskType = consequencesOptions.find((_) => _.name.includes(e.name));
			setCurrentRiskType(e.name);
			if (riskType) {
				setCurrentObject((prevState) => ({ ...prevState, riskType: riskType.name }));
			}
		} else {
			setCurrentObject((prevState) => ({ ...prevState, [field]: e.name }));
		}
	};
	const selectHandlerActual = (e: { [key: string]: any }, field: keyof typeof currentObject) => {
		setCurrentObject((prevState) => ({ ...prevState, [field]: e[field] }));
	};

	return toggle !== null ? (
		<ModalPortal
			outSide={false}
			size={empty ? "sm" : "md"}
			title={empty ? "Невозможно добавить значение" : title}
			handleClose={close}>
			<div className={sass.modal}>
				{!empty && (
					<>
						<InputTemp
							options={shortOptionsRisk as []}
							type={"select"}
							name={"riskType"}
							placeholder={"Введите текст"}
							onSelect={selectHandler}
							field={["name"]}
							value={currentRiskType || ""}
							label={"Виды риска (ущерба) и возможные негативные последствия"}
							required={true}
						/>
						<pre>{currentObject.riskType}</pre>
						<InputTemp
							options={actualViolatorTypes as []}
							errorText={error && currentRiskType ? `Такой вид уже есть в группе ${currentRiskType}` : ""}
							type={"select"}
							name={"type"}
							placeholder={"Введите текст"}
							onSelect={(e) => {
								selectHandlerActual(e, "type");
								selectHandlerActual(e, "inner");
								selectHandlerActual(e, "outer");
							}}
							field={["type"]}
							value={currentObject.type || ""}
							label={"Виды актуального нарушителя"}
							required={true}
						/>

						<GroupCheck.Wrapper label={"Категория нарушителя"} required={true}>
							<GroupCheck.Item
								onChange={changeCheckbox}
								checked={currentObject.outer!}
								name={"outer"}
								label={"Внешний"}
								type={"checkbox"}
							/>
							<GroupCheck.Item
								onChange={changeCheckbox}
								checked={currentObject.inner!}
								name={"inner"}
								label={"Внутренний"}
								type={"checkbox"}
							/>
						</GroupCheck.Wrapper>
						<InputTemp
							placeholder={"Не выбрано"}
							label={"Уровень возможносттей нарушителя"}
							required={true}
							value={currentObject.level!}
							options={options as []}
							onSelect={(e) => {
								selectHandler(e, "level");
							}}
							type={"select"}
							field={["level", "name"]}
						/>
						<div className={sass.btn}>
							<Button onClick={close} variant={BUTTON_VARIANTS.OUTLINED}>
								Отменить
							</Button>
							<Button disabled={disabled} onClick={save} variant={BUTTON_VARIANTS.CONTAINED}>
								Сохранить
							</Button>
						</div>
					</>
				)}
				{renderEmpty}
			</div>
		</ModalPortal>
	) : null;
};

export default CurrentViolantModal;
